import { http } from '@/utils/http/axios'
import { RequestEnum } from '@/enums/httpEnum'
// 返回消息格式
// {
//   code: number;
//   message: string;
//   result: object;
// }

const prefixAPI = '/api'
const prefixTEST = '/test'

/**
 * @description: 获取用户信息
 */
export function getUserInfo() {
  return http.request({
    url: `${prefixAPI}/getUserInfo`,
    method: RequestEnum.GET
  })
}

/**
 * @description: 测试其他域名proxy数据
 */
export function getOtherInfo(params) {
  return http.request(
    {
      url: `${prefixTEST}/get`,
      method: RequestEnum.GET,
      params
    },
    {
      isTransformResponse: false,
      ignoreCancelToken: false
    }
  )
}

/**
 * @description: 用户登录
 */
export function login(params) {
  return http.request(
    {
      url: `${prefixAPI}/login`,
      method: RequestEnum.POST,
      params
    },
    {
      isTransformResponse: false
      // joinPrefix: true,
    }
  )
}

/**
 * @description: 调用api例子：用户修改密码
 */
export function changePassword(params, uid) {
  return http.request(
    {
      url: `${prefixAPI}/user/u${uid}/changepw`,
      method: RequestEnum.POST,
      params
    },
    {
      isTransformResponse: false
    }
  )
}

/**
 * @description: 简单调用api例子: 用户登出
 */
export function doLogout() {
  return http.request({
    url: `${prefixAPI}/logout`,
    method: RequestEnum.POST //也可以是'GET'
  })
}
